
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kategooria/[category-name]",
      function () {
        return require("private-next-pages/kategooria/[category-name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kategooria/[category-name]"])
      });
    }
  